export default __webpack_public_path__ + "static/media/hero-home.3fcdc9ed.jpg";